// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EditData_wrapper__1qgfz","personalDataWrapper":"EditData_personalDataWrapper__1uZo6","bgTransparent":"EditData_bgTransparent__3fzuX"};